import Request from "../Request/Request";
import css from "./Server.module.css";
import { useEffect, useRef, useState } from "react";

const Server = ({ onTimeout, request, onComplete }) => {
  useEffect(() => {
    if (request) {
      processRequest(request);
    }
  }, [request]);

  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const processRequest = async (request) => {
    await wait(request.loadSize * 1000);
    onComplete(request);
  };

  return (
    <div className={`${css.main} ${!!request ? css.busy : ""}`}>
      {request && <Request request={request} onTimeout={onTimeout} />}
      <img
        className={css.icon}
        src="https://cdn-icons-png.flaticon.com/512/716/716180.png"
        alt="server"
      />
    </div>
  );
};

export default Server;
